import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private httpService: HttpService,private httpClient: HttpClient) {}

  exportBankDeposits(data: any) {
    const url = `${environment.OrderApiendpoint}/banckdeposit-export/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  onSaveRating(data: any, id: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/addFeedbackPhlebo?unique_id=${id}`;
    return this.httpService.post(url, data, this.httpService.headers);
  }

  getCompanyDetails(uniqueId: string): Observable<any> {
    const url = `${environment.OrderApiendpoint}/get-company-details?unique_id=${uniqueId}`;
    return this.httpService
        .get(url, this.httpService.headers)
        .pipe(catchError(this.Errorhandling));
  }

  getTotalAmountBankDeposit(visitids: any) {
    const url = `${environment.OrderApiendpoint}/get-total-amount-banckdeposit`;
    const formData = new FormData();

    formData.append('visit_ids', visitids);

    return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getBankDepositDataList(data: any) {
    const url = `${environment.OrderApiendpoint}/get-bank-deposit-data?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientByOrderId(data: any) {
    const url = `${environment.OrderApiendpoint}/list-patient/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getTestforLabLocation(data: any) {
    const url = `${environment.OrderApiendpoint}/getvisitlisting/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  pullreportdata(phone: any, date: any) {
    const url = `${environment.OrderApiendpoint}/GetPatientDetails?Mobile=${phone}&VisitDate=${date}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  additdosReport(data: any) {
    const url = `${environment.OrderApiendpoint}/itdos-report`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPhleboByOrderId(data: any, id: any) {
    const url = `${environment.OrderApiendpoint}/roster_phlebo_listing/${data}?visit_id=${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPhlebos() {
    const url = `${environment.OrderApiendpoint}/get_all_phlebos/`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  deleteBankDeposit(id: any) {
    const url = `${environment.OrderApiendpoint}/banckdeposit/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  addBankDeposit(data: any, imagefile: File, visitids: any) {
    const url = `${environment.OrderApiendpoint}/banckdeposit`;
    const formData = new FormData();

    formData.append('file', imagefile);

    // formData.append('data', data);
    formData.append('data', JSON.stringify(data));
    formData.append('visit_ids', visitids);

    return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  editBankDeposit(data: any, imagefile: File, id: any) {
    const url = `${environment.OrderApiendpoint}/banckdeposit-edit`;
    const formData = new FormData();

    formData.append('file', imagefile);

    // formData.append('data', data);
    formData.append('data', JSON.stringify(data));
    formData.append('id', id);

    return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getBankDeposits(data: any) {
    const url = `${environment.OrderApiendpoint}/banckdeposit?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateModeCash(data) {
    const url = `${environment.OrderApiendpoint}/update-mode-cash/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateAmountParent(data) {
    const url = `${environment.OrderApiendpoint}/update-upsell-amount/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientbyVisitId(data) {
    const url = `${environment.OrderApiendpoint}/get-patientby-visit-id/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientbyId(data) {
    const url = `${environment.OrderApiendpoint}/get-patientby-id/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  UploadReport(formData: any, data: any, file) {
    const allData = new FormData();
    for (let i = 0; i < file.length; i++)
      allData.append('test_report[]', file[i]);
    allData.append('patient_id', formData.patient_id);

    const url = `${environment.OrderApiendpoint}/upload/${data.order_id}/${data.enduser.id}`;
    return this.httpService
      .post(url, allData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  assignPhlebo(formData: any, data: any) {
    const url = `${environment.OrderApiendpoint}/assign_phlebo`;
    return this.httpService
      .put(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  assignPhleboMultipleVisits(formData: any, data: any) {
    const url = `${environment.OrderApiendpoint}/assign_phlebo_multiple`;
    return this.httpService
      .put(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  markavailablereport(data: any) {
    const url = `${environment.OrderApiendpoint}/mark-as-report-available`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getNotImportedOrderList() {
    const url = `${environment.OrderApiendpoint}/get-not-imported-order`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getexportFileList() {
    const url = `${environment.OrderApiendpoint}/get-export-filelist`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getexportFileListNew(exportType: string) {
    const url = `${environment.OrderApiendpoint}/get-export-filelist?export_type=${exportType}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getexportFileListReconcilation() {
    const url = `${environment.OrderApiendpoint}/get-export-filelist-reconcilation`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getAllPhleboList(data: any) {
    const url = `${environment.OrderApiendpoint}/get-areacode-phlebos/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  saveCompleted(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/order-completed/${data}`;
    return this.httpService.patch(url, data, this.httpService.headers);
  }

  exportReconcilation(data: any) {
    const url = `${environment.OrderApiendpoint}/reconcile_export?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  ResetReconcilePhleboStatus(data: any) {
    const url = `${environment.OrderApiendpoint}/reset-reconcile/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  reconcilePhleboStatus(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/reconcile-phlebo-status/`;
    return this.httpService.patch(url, data, this.httpService.headers);
  }

  reconcileBulkPhleboStatus(datavalue: any, data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/reconcile-status-update-bulk/`;
    return this.httpService.post(
      url,
      {
        reconcile_comment: datavalue.reconcile_comment,
        reconcile_amount: datavalue.reconcile_amount,
        visitids: data,
      },
      this.httpService.headers
    );
  }

  cashDepositTo(datavalue: any, data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/cash-deposit-to/`;
    return this.httpService.post(
      url,
      { cash_deposited_to: datavalue.deposittype, visitids: data },
      this.httpService.headers
    );
  }

  getallphlebo(data: any) {
    const url = `${environment.OrderApiendpoint}/all-phlebos/${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getphlebos(data: any, date?: string) {
    let url = `${environment.OrderApiendpoint}/get-all-phlebo/${data}`;
    if (date) {
        url += `?date=${date}`;
    }
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getphlebosByArea(data: any, date?: string) {
    let url = `${environment.OrderApiendpoint}/get-all-areawise-phlebo/${data}`;
     if (date) {
        url += `?date=${date}`;
    }
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // =======================getPhlebo srvice api in order listing===========

  getallPhlebo() {
    const url = `${environment.SettingsApiendpoint}/get-phlebos/`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getAllFacilities() {
    const url = `${environment.LocaionApiendpoint}/location/listFacilities/`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getAllLabs() {
    const url = `${environment.LocaionApiendpoint}/location/listLablocation/`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPhleboView(data: any) {
    const url = `${environment.OrderApiendpoint}/reconcile?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getDateView(data: any) {
    const url = `${environment.OrderApiendpoint}/reconcile-date?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallcancellationreason() {
    const url = `${environment.OrderApiendpoint}/getAllCancellationReason`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getallreschedulereason() {
    const url = `${environment.OrderApiendpoint}/getAllRescheduleReason`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  saveRescheduelReason(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/rescheduleOrder`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

    saveConfirmVisit(data: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/confirmOrder`;
        return this.httpService.post(url, data, this.httpService.headers).pipe(catchError(this.Errorhandling));
    }

  saveLocationLatLongChange(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/updateLocation`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  saveCancellationReason(data: any): Observable<any> {
    // const url = `${environment.OrderApiendpoint}/cancel-visit`;
    const url = `${environment.OrderApiendpoint}/cancelOrder`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  saveDeclineComment(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/decline-order`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  submitToOps(data: any, phlebo: any = 0): Observable<any> {
    const url = `${environment.OrderApiendpoint}/create-batch`;
    return this.httpService
      .post(url, { visitId: data, phleboId: phlebo }, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  submitToOpsGroup(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/submit_ops_group`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  createInvoices(data: any): Observable<any> {
    const formData = {
      visit_ids: data,
    };
    const url = `${environment.OrderApiendpoint}/genrate-invoice`;
    return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getallAreaCode(data: any) {
    const url = `${environment.OrderApiendpoint}/getAreacodeByCity/${data}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getAllSlotForOrder(customer_id: any) {
    const url = `${environment.OrderApiendpoint}/get-customers-slot/${customer_id}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientInsurance(patient_id: any) {
    const url = `${environment.OrderApiendpoint}/patient-insurance/${patient_id}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  downloadMSPForm(visitId: number) {
    const url = `${environment.OrderApiendpoint}/download-msp-form/${visitId}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
// downloadMSPForm(visitId: number): Observable<Blob> {
//     const url = `${environment.OrderApiendpoint}/download-msp-form/${visitId}`;

//     const options = {
//       headers: new HttpHeaders({
//         'Content-Type': 'application/json'
//         // Add any necessary headers here
//       }),
//       responseType: 'blob' as 'json' // responseType is explicitly set to 'blob'
//     };

//     // Now this ensures that the response is properly treated as a Blob
//     return this.httpClient.get<Blob>(url, options); // Specify <Blob> here
//   }
  viewOrderPdf(visitId: number) {
    const url = `${environment.OrderApiendpoint}/order-pdf/${visitId}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPayerList() {
    const url = `${environment.OrderApiendpoint}/get-payer-list/`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getAllSlot(data: any) {
    const url = `${environment.OrderApiendpoint}/customers-area-slot/${data}`;

    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // order
  getOrdersForTableStat(data: any) {
    const url = `${environment.OrderApiendpoint}/orders?t=order-stat${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  // order
  getOrdersForTable(data: any) {
    const url = `${environment.OrderApiendpoint}/orders?t=order${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getOrdersForCalender(data: any) {
    const url = `${environment.OrderApiendpoint}/calender-view?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  postOrder(data: any, screenName: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/orders?t=${screenName}`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getSingleOrderData(id: any) {
    const url = `${environment.OrderApiendpoint}/view-master-order/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getSingleOrderDataView(id: any, visitId: any) {
    const url = `${environment.OrderApiendpoint}/view-master-order-with-visit/${id}/${visitId}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // report
  getreportlist(order_id: any) {
    const url = `${environment.OrderApiendpoint}/report-list/${order_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  deletereport(id: any) {
    const url = `${environment.OrderApiendpoint}/delete-report/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getSingleOrderPublicData(id: any) {
    const url = `${environment.OrderApiendpoint}/view-master-order-public/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  paymentqr(id: any) {
    const url = `${environment.OrderApiendpoint}/create-paymentqr/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  orderQuickStat() {
    const url = `${environment.OrderApiendpoint}/order-status-list`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getSingleOrderData_by_visit_id(id: any, visit_id: any) {
    const url = `${environment.OrderApiendpoint}/view-master-order-visit/${id}/${visit_id}/`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateOrder(data: any, id: any, screenName: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/orders/${id}/?t=${screenName}`;
    return this.httpService
      .put(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  orderDelete(id: any, screenName: any) {
    const url = `${environment.OrderApiendpoint}/orders/${id}?t=${screenName}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  orderDeleteLocas(id: any) {
    const url = `${environment.OrderApiendpoint}/delete-task/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  exportOrder(data: any) {
    const url = `${environment.OrderApiendpoint}/orders?t=orders_export${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  uploadOrders(imagefile: File) {
    const url = `${environment.OrderApiendpoint}/orders-import`;
    const formData = new FormData();
    formData.append('file', imagefile);

    return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  createPatient(data: any) {
    const url = `${environment.EnduserApiendpoints}/addPatient`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  editPatient(data: any) {
    const url = `${environment.EnduserApiendpoints}/editPatient`;
    return this.httpService
      .put(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  createAddress(data: any) {
    const url = `${environment.EnduserApiendpoints}/addAddress`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateAddress(data: any) {
    const url = `${environment.EnduserApiendpoints}/editAddress`;
    return this.httpService
      .put(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  deletePatient(id: any, user_id: any) {
    const url = `${environment.EnduserApiendpoints}/deletePatient?id=${id}&user_id=${user_id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  deleteAddress(id: any, user_id: any) {
    const url = `${environment.EnduserApiendpoints}/deleteAddress?address_id=${id}&user_id=${user_id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updatePatient(data: any, id: any) {
    const url = `${environment.OrderApiendpoint}/api/v1/order/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  GetAllLabLocation(customer_id: any, cityId: any, provider_id: any) {
    const url = `${environment.OrderApiendpoint}/get-lab-location/${customer_id}/${cityId}/${provider_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  addlablocationBytest(data: any) {
    const url = `${environment.OrderApiendpoint}/addvisittestlab`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallTest_code(customer_id: any, cityId: any, labid: any) {
    const url = `${environment.OrderApiendpoint}/get-tests/${customer_id}/${cityId}/${labid}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallTest_codeByProvider(
    customer_id: any,
    provider_id: any,
    cityId: any,
    labid: any
  ) {
    const url = `${environment.OrderApiendpoint}/get-tests-provider/${customer_id}/${provider_id}/${cityId}/${labid}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientForTable(id: any) {
    const url = `${environment.OrderApiendpoint}/get-patient-list/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getOrderTimeline(visit_id: any) {
    const url = `${environment.OrderApiendpoint}/visit-status/${visit_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getPhlebolocations(visit_id: any, phlebo_id: any) {
    const url = `${environment.OrderApiendpoint}/phlebo-all-locations?visit_id=${visit_id}&phlebo_id=${phlebo_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  barcodesAndDocument(id: any) {
    const url = `${environment.PhleboApiendpoint}/visitbarcode-listing/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getRunnerbyBarcode(id: any) {
    const url = `${environment.RunnerApiendpoint}/web-runner-listing/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  CreateOrderViewPDF(visit_id: any) {
    const url = `${environment.OrderApiendpoint}/generate-order-view-pdf/${visit_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  CreateOrderViewPDFPUBLIC(visit_id: any) {
    const url = `${environment.OrderApiendpoint}/generate-order-view-pdf-public/${visit_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  downloadTrf(visit_id: any) {
    const url = `${environment.OrderApiendpoint}/generate-order-trf-pdf/${visit_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  downloadReceipt(visit_id: any) {
    const url = `${environment.OrderApiendpoint}/get-Receipt/${visit_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getallSlot(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/getSlotForCustomer?address_id=${data.address}&date=${data.date}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getBookingSlot(): Observable<any> {
    const url = `${environment.OrderApiendpoint}/getBookingSlotForCustomer`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallSlotCustomer(data: any, customer_id): Observable<any> {
    const url = `${environment.OrderApiendpoint}/getSlotForCustomerWeb?customer_id=${customer_id}&address_id=${data.address}&date=${data.date}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  addTest(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/addMasterCart`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  addTestWeb(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/addMasterCartWeb`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  createOrder(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/addOrder`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  updateOrderData(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/updateOrder`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateAssignLab(data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/assign_lab/${data}`;
    return this.httpService
      .post(url, [], this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getallBookings(id: any): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/viewCart?user_id=${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallBookingsWeb(id: any, customer_id: any): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/viewCartWeb?user_id=${id}&customer_id=${customer_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getallTests(address_id): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/getTest?address_id=${address_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getallTestsCusertomer(address_id, customer_id): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/getTestWeb?address_id=${address_id}&customer_id=${customer_id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  applyCoupon(code: any): Observable<any> {
    const url = `${environment.CustomerApiendpoint}/verify_coupon?coupon_code=${code}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  removeBookingItem(user_id: any, id: any): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/deleteCart?user_id=${user_id}&id=${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  removeBookingItemByPatient(user_id: any, id: any): Observable<any> {
    const url = `${environment.EnduserApiendpoints}/deleteCartbypatientID?enduser_id=${user_id}&patient_id=${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // getTestsForTable(id:any) {
  //     const url = `${environment.OrderApiendpoint}/get-patient-list/${id}`;
  //     return this.httpService.get(url, this.httpService.headers)
  //         .pipe(catchError(this.Errorhandling))
  // }
  // getTestsForTableByVisit(id:any, visitId:any) {
  //     const url = `${environment.OrderApiendpoint}/get-patient-list/${id}/${visitId}`;
  //     return this.httpService.get(url, this.httpService.headers)
  //         .pipe(catchError(this.Errorhandling))
  // }
  getPatientForTableByVisit(id: any, visitId: any) {
    const url = `${environment.OrderApiendpoint}/get-patient-list-by-order-visit/${id}/${visitId}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getAvailableSlot(customer_id: any, pincode: any, date: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/get-available-slot`;
    return this.httpService
      .post(
        url,
        { customer_id, pincode, date },
        this.httpService.headers
      )
      .pipe(catchError(this.Errorhandling));
  }

  edit_patient_test(id: any, data: any): Observable<any> {
    const url = `${environment.OrderApiendpoint}/edit-patient-test/${id}`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getTestForTableByVisit(id: any, visitId: any) {
    const url = `${environment.OrderApiendpoint}/get-test-list-by-order-visit/${id}/${visitId}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getPatientForDropdownVisit(id: any, visitId: any) {
    const url = `${environment.OrderApiendpoint}/get-patient-list-for-dropdown-visit/${id}/${visitId}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getTotalAmount(id: any) {
    const url = `${environment.OrderApiendpoint}/get-total-amount/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getTotalAmountNew(id: any) {
    const url = `${environment.OrderApiendpoint}/get-total-amount-new/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  getPatientForDropdown(id: any) {
    const url = `${environment.OrderApiendpoint}/get-patient-list-for-dropdown/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientForTableByOrder(id: any) {
    const url = `${environment.OrderApiendpoint}/get-patient-list-by-order/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getPatientForTableByOrderPublic(id: any) {
    const url = `${environment.OrderApiendpoint}/get-test-list-by-order-visit-public/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  // getBarcodeAndDocument(id: any) {
  //     const url = `${environment.OrderApiendpoint}/visit-checklist/${id}`;
  //     return this.httpService.get(url, this.httpService.headers)
  //         .pipe(catchError(this.Errorhandling))
  // }
  getVisitStatusList(id: any) {
    const url = `${environment.OrderApiendpoint}/visit-status/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  cancelOrder(id: any) {
    const url = `${environment.OrderApiendpoint}/cancel-visit/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  rescheduleOrder(id: any) {
    const url = `${environment.OrderApiendpoint}/reshedule-visit/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  upSellOrder(id: any) {
    const url = `${environment.OrderApiendpoint}/upsell-visit/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  // upSellOrder

  // https://mtqn0qowxc.execute-api.us-east-1.amazonaws.com/get-temprature/visit_id

  viewTemperature(id: any) {
    const url = `${environment.OrderApiendpoint}/get-temprature/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  searchNumber(data: any) {
    const url = `${environment.CustomerApiendpoint}/searchByMobile`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

getFacility(id: any) {
    const url = `${environment.CustomerApiendpoint}/get-facility/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  addLocation(data: any) {
    const url = `${environment.CustomerApiendpoint}/add-location`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  
  searchNumberBycustomer(data: any) {
    const url = `${environment.CustomerApiendpoint}/searchByMobileCustomer`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  obtainTaskGPS(id: any) {
    const url = `${environment.OrderApiendpoint}/get-all-gps-phlebo/${id}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // Insurance start
  createInsurance(data: any) {
    const url = `${environment.OrderApiendpoint}/create-insurance`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateInsurance(data: any) {
    const url = `${environment.OrderApiendpoint}/update-insurance`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  deleteInsuranceItem(id: any) {
    const url = `${environment.OrderApiendpoint}/delete-insurance/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  setDefaultInsurance(id: any) {
    const url = `${environment.OrderApiendpoint}/set-default-insurance/${id}`;
    return this.httpService
      .post(url, [], this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  // Insurance End
  // ICD codes start
  saveIcdCodes(data: any) {
    const url = `${environment.OrderApiendpoint}/add-icd-code`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  // ICD codes End
  // Order provider Start
  getAllProviders() {
    const url = `${environment.OrderApiendpoint}/all-provider-list`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getProviderList(data: any) {
    const url = `${environment.OrderApiendpoint}/provider-list?${data}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }

  addProvider(data: any) {
    const url = `${environment.OrderApiendpoint}/add-provider`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  updateProvider(data: any) {
    const url = `${environment.OrderApiendpoint}/update-provider`;
    return this.httpService
      .post(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  deleteProvider(id: any) {
    const url = `${environment.OrderApiendpoint}/delete-provider/${id}`;
    return this.httpService
      .delete(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getProvidersByFacility(facilityId) {
    const url = `${environment.OrderApiendpoint}/all-provider-list?facility_id=${facilityId}`;
    return this.httpService
      .get(url, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
  getChangePhleboAndSlot(data: any) {
    const url = `${environment.OrderApiendpoint}/update-phlebo-slot`;
    return this.httpService
      .put(url, data, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
  }
// download837PForm start
download837PForm(visitId: number): Observable<Blob> {
  const url = `${environment.OrderApiendpoint}/download-837p-form/${visitId}`;

  const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
      // 'Authorization': `Bearer ${yourToken}` // ← Optional if you're using JWT
    }),
    responseType: 'blob' as 'json'  // 👈 required for file download
  };

  return this.httpClient.get<Blob>(url, options);
}

// download837PForm end

  // Order Provider End
  Errorhandling(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
      console.error(err.error.message);
    } else {
      console.error(`Backend returned code ${err.status}`);
    }
    return throwError('Please try again later.');
  }
}
